import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { ReturnRequestDebugView } from "@/components/return-request-debug-view/return-request-debug-view";
import { useViewerHasAtLeastLogisticianRights } from "@/lib/rights/use-viewer-has-right";
import FinancialCard from "@/pages/(app)/returns/view/components/financial-card/financial-card";
import Activity from "@/pages/(app)/returns/view/components/return-activity/activity";
import { ExchangeOrderCard } from "@/pages/(app)/returns/view/components/exchange-order-card/exchange-order-card";
import { ListExchangeCreditArticle } from "@/pages/(app)/returns/view/components/return-articles/list-exchange-credit-article";
import ReturnRequestArticles from "@/pages/(app)/returns/view/components/return-articles/return-request-articles";
import { useUnreadNotes } from "@/pages/(app)/returns/view/hooks/use-unread-notes";
import { Card, CardContent } from "@babackapp/ui/components/card";
import { Label } from "@babackapp/ui/components/label";
import { useCallback } from "react";
import { useCurrentReturnRequest } from "../../../utils/current-return-request-context";
import ReturnSidebar from "../return-sidebar/return-sidebar";
import ReturnDetailsHeader from "./return-details-header";
import useTranslation from "@babackapp/translations/use-translation";

export default function ReturnContent() {
  const returnRequest = useCurrentReturnRequest();
  const { data: shop } = useCurrentShopSuspense();

  const hasLogisticianRights = useViewerHasAtLeastLogisticianRights();
  const t = useTranslation();

  const { unreadCount, markAsRead } = useUnreadNotes(
    returnRequest.id,
    returnRequest.logs,
  );

  const scrollToActivity = useCallback(() => {
    document
      .getElementById("return-request-activities")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="flex xl:flex-row flex-col-reverse justify-center gap-4 items-start relative w-full">
      <div className="flex flex-col w-full xl:w-auto gap-8">
        <Card
          className={
            "flex flex-1 flex-col gap-3 flex-grow xl:w-[740px] bg-white w-full"
          }
        >
          <CardContent className="py-8 px-8 flex flex-col gap-4">
            <ReturnDetailsHeader
              unreadCount={unreadCount}
              scrollToActivity={scrollToActivity}
            />
            {hasLogisticianRights && (
              <FinancialCard returnRequest={returnRequest} shop={shop} />
            )}
            <Label>{t("returnDetail.article_other")}</Label>
            <ReturnRequestArticles />
            <ListExchangeCreditArticle
              returnRequest={returnRequest}
              shop={shop}
            />
            <ExchangeOrderCard />
            <Activity returnRequest={returnRequest} markAsRead={markAsRead} />
          </CardContent>
        </Card>
        <ReturnRequestDebugView returnRequest={returnRequest} />
      </div>
      <ReturnSidebar returnRequest={returnRequest} />
    </div>
  );
}
